var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "swiper swiper-container ob1-carrousel mb-0",
        style: _vm.cssVars,
        attrs: { tabindex: "-1", id: _vm.uniqSwiperId },
      },
      [
        _c(
          "div",
          {
            staticClass: "swiper-wrapper",
            attrs: { id: _vm.uniqSwiperWrapperId },
          },
          [_vm._t("default")],
          2
        ),
        _vm._v(" "),
        _vm.scrollbarConfiguration
          ? _c("div", { staticClass: "swiper-scrollbar" })
          : _vm._e(),
        _vm._v(" "),
        _vm.paginationConfiguration
          ? _c("div", { staticClass: "row" }, [
              _c("ol", {
                staticClass: "swiper-pagination ob1-page-indicator",
                class: { "d-none": _vm.swipeContentTooSmallToSwipe },
                attrs: { "aria-hidden": "true" },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "swiper-navigation",
            class: {
              "d-none": !_vm.navigation || _vm.swipeContentTooSmallToSwipe,
            },
            attrs: { id: _vm.uniqSwiperNavigationId },
          },
          [
            _c(
              "button",
              {
                staticClass: "swiper-button-prev",
                class: {
                  "d-none": _vm.hideNavigationForSmallScreens,
                  "d-md-block": _vm.hideNavigationForSmallScreens,
                  "swiper-button-hidden-when-disabled":
                    _vm.hideDisabledNavigationPrevEl,
                },
                attrs: { title: "Précédent" },
              },
              [
                _c("span", { staticClass: "visually-hidden" }, [
                  _vm._v("Précédent"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "swiper-button-next",
                class: {
                  "d-none": _vm.hideNavigationForSmallScreens,
                  "d-md-block": _vm.hideNavigationForSmallScreens,
                  "swiper-button-hidden-when-disabled":
                    _vm.hideDisabledNavigationNextEl,
                },
                attrs: { title: "Suivant" },
              },
              [
                _c("span", { staticClass: "visually-hidden" }, [
                  _vm._v("Suivant"),
                ]),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }